// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"991d18cbf60541607666","116":"a74eb5cc7e795b72b72d","117":"91bbdba5cf0bab37fd6d","164":"2857b8507db665e20be5"}[chunkId] + ".chunk.js";
};